<template>
  <div class="lv-state-ques-condition-list">
    <div v-if="list && list.length">
      <LvStateQuesCondition
        v-for="(condition, conditionIndex) in list"
        :key="conditionIndex"
        :operator="condition.operator"
        :lowVal="condition.lowVal"
        :highVal="condition.highVal"
        :risk="condition.risk"
        class="lv-state-ques-condition-list__condition"
        @input="$_onInput($event, conditionIndex)"
        @delete="$emit('delete', conditionIndex)"
      />
    </div>
    <LvFlexBox v-else noWrap alignItems="start" class="mb-8">
      <LvText h3 red><i class="icon-info" /></LvText>
      <LvText h6 red class="ml-6">{{ $t('必須至少設定1個條件規則！') }}</LvText>
    </LvFlexBox>
    <WsTextButton001
      small
      primary
      noPadding
      leadingIcon="icon-bih-add-circle"
      @click="$emit('add')"
    >{{ $t('新增') }}</WsTextButton001>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    }
  },
  methods: {
    $_onInput($event, conditionIndex) {
      const { value, type } = $event;
      this.$emit('input', {
        index: conditionIndex,
        value: {
          ...this.list[conditionIndex],
          [type]: value,
        },
      });
    },
  }
}
</script>